<template>
  <div class="date-picker-message">
    <div class="avatar">
      <img src="@/assets/images/robot.png" class="avatar-img" alt="AI" />
    </div>
    <div class="message-body">
      <div class="sender-name">智能助手</div>
      <div class="bubble">
        <div class="content" v-if="msg.content">{{ msg.content }}</div>
        <van-button
          color="#1989fa"
          round
          block
          class="date-btn"
          :loading="msg.loadingDates"
          :disabled="msg.verified || msg.loadingDates"
          @click="fetchDates"
        >{{ msg.verified ? '已选择' : '请选择预约日期' }}</van-button>
        <div class="bubble-footer" v-if="msg.time">
          <div class="time">{{ msg.time }}</div>
        </div>
      </div>
      <div class="progress" v-if="msg.progress">{{ msg.progress }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DatePickerMessage',
  props: {
    msg: { type: Object, required: true },
    index: { type: Number, default: 0 },
  },
  methods: {
    fetchDates() {
      this.$emit('fetch-dates', this.index);
    },
  },
};
</script>

<style lang="scss" scoped>
.date-picker-message {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}
.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  flex-shrink: 0;
  background: #e8f8ff;
}
.avatar-img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.message-body {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.bubble {
  display: inline-block;
  max-width: 75%;
  margin: 0 30px;
  padding: 10px 12px;
  border-radius: 12px;
  background: #fff;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
}
.sender-name {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
  margin-left: 30px;
}
.content {
  white-space: pre-line;
}
.date-btn {
  margin-top: 8px;
}
.bubble-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 8px;
  min-height: 18px;
}
.bubble-footer .time {
  font-size: 12px;
  color: #999;
}
.progress {
  font-size: 12px;
  color: #999;
  margin: 4px 30px 0;
}
</style>